import LinkButton from '../../../components/link-button/link-button'
import config from '../../../config'
import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import {
  getCreditBatchSourceTypeLabel,
  getCreditBatchStatusLabel,
} from '../../../pages/credit-batches-container/constant'
import { ICreditBatch } from '../../../pages/credit-batches-container/share-type'
import { Button, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { TablePaginationConfig } from 'antd/lib/table/interface'

const { guavapassUrl } = config

const CreditBatchesList = ({
  creditBatches,
  pagination,
  onPaginationChange,
}: {
  creditBatches: ICreditBatch[]
  pagination: TablePaginationConfig
  onPaginationChange: (page: number, pageSize: number) => void
}) => {
  const columns: ColumnsType<ICreditBatch> = [
    {
      title: 'ID',
      dataIndex: 'id',
      render: id => <LinkButton to={`/credit-batches/${id}`}>{id}</LinkButton>,
    },
    {
      title: translate('creditBatches.user'),
      render: record => (
        <Button type="link" target="_blank" href={`${guavapassUrl}/admin/users/${record.userId}`}>
          {record.userName ? `User#${record.userId} ${record.userName}` : `User#${record.userId}`}
        </Button>
      ),
    },
    {
      title: translate('creditBatches.sourceType'),
      dataIndex: 'sourceType',
      render: getCreditBatchSourceTypeLabel,
    },
    { title: translate('creditBatches.sourceId'), dataIndex: 'sourceId' },
    { title: translate('creditBatches.issuedCredits'), dataIndex: 'issuedCredits' },
    { title: translate('creditBatches.remainingCredits'), dataIndex: 'remainingCredits' },
    {
      title: translate('creditBatches.status'),
      dataIndex: 'status',
      render: getCreditBatchStatusLabel,
    },
    { title: translate('creditBatches.createdAt'), dataIndex: 'createdAt', render: getDateTime },
    { title: translate('creditBatches.expiresAt'), dataIndex: 'expiresAt', render: getDateTime },
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={creditBatches}
      pagination={pagination}
      onChange={paginationConfig =>
        onPaginationChange(paginationConfig.current || 1, paginationConfig.pageSize || 10)
      }
      size="small"
    />
  )
}

export default CreditBatchesList
